import { EditableDataGrid } from "../../../builderPackage/components/editableDataGrid/editableDataGrid";
var ChecklistDataGridView = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? "PartDetails" : _a;
    var ChecklistColumns = [{
            field: "srNo",
            headerName: "Sr. no.",
            width: 100,
            editable: false,
            sortable: false,
            renderCell: function (params) { return params.api.getAllRowIds().indexOf(params.id) + 1; }
        }, {
            field: "whatToCheck",
            headerName: "What to check",
            flex: 1,
            editable: false
        }, {
            field: "howToConfirm",
            headerName: "How to confirm",
            flex: 1,
            editable: false
        }, {
            field: "importance",
            headerName: "Importance",
            flex: 1,
            editable: false
        }, {
            field: "remark",
            headerName: "Remark",
            flex: 1,
            editable: false
        }];
    return name !== 'catalog' ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditableDataGrid, {
        columns: ChecklistColumns,
        rows: (value === null || value === void 0 ? void 0 : value.ChecklistData) || [],
        disableAddRow: true,
        dataGridHeader: "Checklist",
        disableDeleteRow: true,
        disableToolbarActions: true,
        dataGridProps: {
            hideFooter: true,
            disableColumnMenu: true,
            checkboxSelection: false,
            sx: {
                mt: 2,
                '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: 'background.secondary',
                    width: '100%'
                },
                '& .MuiDataGrid-row': {
                    backgroundColor: 'background.secondary'
                }
            }
        }
    })) : /*#__PURE__*/ React.createElement("div", {
        style: {
            display: "flex",
            justifyContent: "center"
        }
    }, /*#__PURE__*/ React.createElement("h4", null, "Coming soon...!"));
};
export default ChecklistDataGridView;
